import { render } from "./PartnersProfile.vue?vue&type=template&id=57de64d1&scoped=true"
import script from "./PartnersProfile.vue?vue&type=script&lang=js"
export * from "./PartnersProfile.vue?vue&type=script&lang=js"

import "./PartnersProfile.vue?vue&type=style&index=0&id=57de64d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57de64d1"]])

export default __exports__